module.exports = __webpack_public_path__ + "img/1565591091.63ac18c9.jpg";